export default __webpack_public_path__ + "static/media/car-fixing-6.0c457af7.jpg";